import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { autoHyphen } from '../../../utils/replace';
import { isNull } from 'lodash';
import Button from '../../../components/Button';
import { isEmpty } from '../../../utils/lodashExtend';
import { ControlTable } from '../../../components/Table';
import systemAlert from '../../../utils/systemAlert';
import { viewLoading } from '../../../utils/loading';
import { deleteBanksTransItems } from '../../../apis/finances/bank';
import RelatedModal from './RelatedModal';

const DetailBody = ({ formData, permission, submit, totalSubmit, open }) => {
  // 연관 세금계산서 리스트
  const [taxInvoiceFields, setTaxInvoiceFields] = useState([]);
  const [taxInvoiceList, setTaxInvoiceList] = useState([]);
  const [paperTaxInvoiceList, setPaperTaxInvoiceList] = useState([]);
  // 연관 거래명세서 리스트
  const [tradeInvoiceFields, setTradeInvoiceFields] = useState();
  const [tradeInvoiceList, setTradeInvoiceList] = useState([]);
  // 연관 카드내역 리스트
  const [cardFields] = useState([
    { title: "거래일자", key: "trDate", type: "date" },
    { title: "지급예정일", key: "payDate", type: "date" },
    { title: "카드사", key: "cardCompany1" },
    { title: "결제금액", key: "buyAmt", type: "comma" },
    { title: "수수료", key: "totalCommAmt", type: "comma" },
    { title: "지급예정액", key: "payAmt", type: "comma" },
  ]);
  const [cardList, setCardList] = useState([]);
  // 연관 현금영수증 리스트
  const [cashFields, setCashFields] = useState([]);
  const [cashList, setCashList] = useState([]);
  // 연관 데이터 오픈
  const [relatedListOpen, setRelatedListOpen] = useState(false);
  // 연관 항목 권한
  const [targetPermission, setTargetPermission] = useState([]);
  const { permissions } = useSelector((store) => ({
    permissions: store.Profile.permissions
  }));

  useEffect(() => {
    if (open) {
      // 관련항목 권한체크
      const permissionTarget = ['TAX_INVOICE', 'TRADE_INVOICE', 'CASH_INVOICE', 'FUND_CARD_HISTORY'];
      const targetPermissions = permissions.filter((p) => permissionTarget.includes(p.code));
      setTargetPermission(targetPermissions);
    }
  }, [permissions, open]);


  useEffect(() => {
    // 세금계산서 필드
    setTaxInvoiceFields([
      { title: "일자", key: "writeDate", type: 'date' },
      { title: "상호", key: formData.inAmt > 0 ? "byrCorpName" : "supCorpName" },
      { title: "대표자명", key: formData.inAmt > 0 ? "byrRepName" : "supRepName" },
      {
        title: "사업자번호",
        key: formData.inAmt > 0 ? "byrBizNo" : "supBizNo",
        onValue: (value) => {
          return autoHyphen("comNum", value);
        },
      },
      {
        title: "공급가액",
        key: "supplyAmt",
        type: 'comma'
      },
      {
        title: "세액",
        key: "taxAmt",
        type: 'comma'
      },
      {
        title: "합계금액",
        key: "totalAmt",
        type: 'comma'
      },
    ]);
    // 거래명세서 필드
    setTradeInvoiceFields([
      { title: "일자", key: "writeDate", type: 'date' },
      { title: "상호", key: formData.inAmt > 0 ? "byrCorpName" : "supCorpName" },
      { title: "대표자명", key: formData.inAmt > 0 ? "byrRepName" : "supRepName" },
      {
        title: "사업자번호",
        key: formData.inAmt > 0 ? "byrBizNo" : "supBizNo",
        onValue: (value) => {
          return autoHyphen("comNum", value);
        },
      },
      {
        title: "공급가액",
        key: "supplyAmt",
        type: 'comma'
      },
      {
        title: "세액",
        key: "taxAmt",
        type: 'comma'
      },
      {
        title: "합계금액",
        key: "totalAmt",
        type: 'comma'
      },
      {
        title: "발행여부",
        key: "taxInvoiceIdx",
        onValue: (value, field, form) => {
          let issue = "";
          if (isNull(value)) {
            issue = "부";
          } else {
            // TODO 나중에 현금영수증 발급 추가 될 경우... 변경해야함
            issue = "세금계산서";
          }

          return issue;
        },
      },
    ]);
    // 현금영수증 필드
    setCashFields([
      { title: "일자", key: "tradeTime", type: 'date' },
      { title: "승인번호", key: "apprNo" },
      { title: "발급수단번호", key: "frPartNo" },
      { title: formData.inAmt > 0 ? "거래구분" : "공제구분", key: formData.inAmt > 0 ? "trGb" : "ddcYn" },
      { title: "공급가액", key: "supAmt" },
      { title: "부가세", key: "taxAmt" },
      { title: "봉사료", key: "tip" },
      { title: "총 거래금액", key: "totAmt" },
    ]);

    if (!isEmpty(formData)) {
      const { invoices, taxInvoices, cardSales, cashReceiptPurchases, cashReceiptSales } = formData;
      const paperTaxInvoices = taxInvoices?.filter(f => f.invoiceType === "paper_tax_invoice");
      setTaxInvoiceList(taxInvoices?.filter(f => f.invoiceType !== "paper_tax_invoice"));
      setPaperTaxInvoiceList(paperTaxInvoices);
      setTradeInvoiceList(invoices);
      setCardList(cardSales);
      if (formData.inAmt > 0) {
        setCashList(cashReceiptSales);
      }
      if (formData.outAmt > 0) {
        setCashList(cashReceiptPurchases);
      }
    }


  }, [formData]);


  const rowBtnConfig = {
    rowButtons: [
      {
        label: "삭제",
        type: "delete",
        className: "margin-right-8",
        action: (rowData) => {
          systemAlert('해당 연관 데이터를 삭제하시겠습니까?', {
            buttons: [
              {
                color: 'text',
                label: '취소'
              },
              {
                label: '삭제',
                onClick: () => {
                  viewLoading(true);
                  deleteBanksTransItems(rowData.bankTransItem.idx)
                    .then(() => { submit(); })
                    .catch(() => { })
                    .finally(() => viewLoading(false));
                }
              }
            ]
          });
        },
      },
    ],
  };


  return (
    <div className="bank-summaries-detail">
      <div className="related-container">
        {permission.level > 1 && (
          <div className="related-header">
            <Button
              className="add-related-btn"
              size="sm"
              color="line"
              label="관련항목 추가"
              disabled={isEmpty(targetPermission)}
              onClick={() => setRelatedListOpen(true)}
            />
          </div>
        )}
        {!isEmpty(taxInvoiceList) && (
          <div className="related-body">
            <label className="related-header-title">
              연관 전자(세금)계산서
            </label>
            <ControlTable fields={taxInvoiceFields} list={taxInvoiceList} rowBtn={permission.level > 1 ? rowBtnConfig : {}} />
          </div>
        )}
        {!isEmpty(paperTaxInvoiceList) && (
          <div className="related-body">
            <label className="related-header-title">
              연관 종이(세금)계산서
            </label>
            <ControlTable fields={taxInvoiceFields} list={paperTaxInvoiceList} rowBtn={permission.level > 1 ? rowBtnConfig : {}} />
          </div>
        )}
        {!isEmpty(tradeInvoiceList) && (
          <div className="related-body">
            <label className="related-header-title">
              연관 거래명세서
            </label>
            <ControlTable fields={tradeInvoiceFields} list={tradeInvoiceList} rowBtn={permission.level > 1 ? rowBtnConfig : {}} />
          </div>
        )}
        {!isEmpty(cardList) && (
          <div className="related-body">
            <label className="related-header-title">
              연관 카드 매출 내역
            </label>
            <ControlTable fields={cardFields} list={cardList} rowBtn={permission.level > 1 ? rowBtnConfig : {}} />
          </div>
        )}
        {!isEmpty(cashList) && (
          <div className="related-body">
            <label className="related-header-title">
              연관 현금영수증 내역
            </label>
            <ControlTable fields={cashFields} list={cashList} rowBtn={permission.level > 1 ? rowBtnConfig : {}} />
          </div>
        )}
      </div>

      <RelatedModal
        open={relatedListOpen}
        setOpen={setRelatedListOpen}
        bankData={[formData]}
        submit={totalSubmit}
        permissions={targetPermission}
      />
    </div>
  );
};

export default DetailBody;